module.exports = __webpack_public_path__ + "static/media/sliderHome3.55953f94.jpg";